import styles from "./Dashboard.module.scss";
import { motion } from "framer-motion";
import { animatePage } from "../../animation/animationPage";

import { useContext } from "react";
import NavContext from "../../context/NavContext";

import Calibration from "components/calibration/Calibration";
import { UserInviteProvider } from "context/UserInviteContext";
import { CabineProvider } from "context/CabineContext";
import Team from "components/Team/Team";
import DownloadOwner from "components/DownloadOwner/DownloadOwner";
import Faq from "components/FAQ/Faq";




const Dashboard = () => {
  const { user } = useContext(NavContext);

  return (
    <motion.main
      className={styles.container}
      variants={animatePage}
      exit="exit"
      initial="hidden"
      animate="visible"
    >
      {/* ✅ LES PROVIDERS MÉTIER DOIVENT ÊTRE AU-DESSUS DU PANEL */}
    <UserInviteProvider>
    <CabineProvider>
     
          <div className={styles.grid}>
            <section className={styles.panel}>
              <Calibration />
            </section>

            {!user && (
              <section className={styles.panel}>
                <Team />
              </section>
            )}

            {!user && (
              <section className={styles.panel}>
                <DownloadOwner />
              </section>
            )}

            <div className={styles.faqWrap}>
              <Faq />
            </div>
          </div>
       

    </CabineProvider>
  </UserInviteProvider>
    </motion.main>
  );
};

export default Dashboard;
